import { getBase64, urlToFileModel } from "../../../../utils/file";

export const onSetImage = ({ props, event, VueDrawingCanvas }) => {
    const file = event?.target?.files?.[0];
    getBase64(file, (fileModel) => {
        props.options.backgroundImage = fileModel.base64;
        redraw({VueDrawingCanvas})
    }, { isFull: true });
}

export const redraw = ({ VueDrawingCanvas, callback }) => {
    VueDrawingCanvas?.redraw?.().then(()=>{
        VueDrawingCanvas?.redraw?.().then(()=>{
            VueDrawingCanvas?.redraw?.().then(() => {
                callback?.()
            });
        })
    });
}

export const initData = ({ props, data, VueDrawingCanvas }) => {
    const { signatureFile } = props
    const file = signatureFile?.();
    if (file) {
        urlToFileModel({
            file: signatureFile(),
            callback: (fileModel) => {
                props.options.backgroundImage = fileModel.base64
                redraw({
                    VueDrawingCanvas: VueDrawingCanvas.value,
                    callback: () => {
                        data.isInit = true;
                    }
                });
            },
            options: { isFull: true }
        });
    }
}